@if (this.data['fields']) {
  @if (config.filterAr != undefined && config.filterAr.length) {
    <div class="bookmarks-container ml-2 mr-2">
      <div class="col-12 p-0">
        @for (filter of config.filterAr; track filter) {
          <div class="fav-bookmark">
            <div class="bookmark-chip"
              [ngClass]="(config.filterConfig!=undefined && config.filterConfig.FilterName!=undefined) &&  (filter.name == config.filterConfig.FilterName) ? 'active': ''"
              style="cursor: pointer;">
              <span class="" (click)="applyFilter(filter)"> {{ filter.name }}</span>
              <!-- <i class="fa fa-filter" (click)="applyFilter(filter)"></i> -->
              <!-- (click)="resetFilter(filter)" -->
              @if ((config.filterConfig!=undefined && config.filterConfig.FilterName!=undefined) &&  (filter.name == config.filterConfig.FilterName)) {
                <i class="fa fa-check ml-1"
                ></i>
              }
            </div>
          </div>
        }
        @if (config.localStorageData && config.localStorageData['filter__'] != undefined && config.localStorageData['filter__'].length >0) {
          <a href="javascript:void(0)" (click)="manageFilter()"
            >
            <img src="assets/images/icon-context.svg">
          </a>
        }
      </div>
    </div>
  }
  <div class="row-bulk-screen">
    <div class="table-action-container w-100 mt-3">
      <div class="d-flex align-items-center">
        <div class="_filter-button-wrapper">
          <ng-container>
            <div class="_filter-button" (click)="displayFilter()">
              <!-- <span class="filter-buttonname d-inline">{{'Filter' | translate |
            async}}</span> -->
            <i class="fa fa-filter " aria-hidden="true"></i>
          </div>
        </ng-container>
      </div>
      <div class="w-100-mobile">
        <!------Common Search box------------------------------------------------>
        <div class="grid-search-wrapper has-filter">
          <div class="grid-smart-search-container mr-2 w-100-mobile">
            <!-- <div class="grid-smart-search-container d-flex align-items-center"> -->
            <app-complex-search [config]="searchConfig" (onFilterChange)="filterClick($event);" class="w-100-mobile">
            </app-complex-search>
          </div>
        </div>
      </div>
      <div class="switch-class">
        <div style="margin-right:5px" class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="switch{{i}}"
            (change)="getBloodBankOrders($event.target.value)" [(ngModel)]="bloodBankOrdersToggle">
          <label class="custom-control-label" for="switch{{i}}">BB Order Sorting</label>
        </div>
      </div>
      <div class="ml-auto">
        @if (!utilService.isOnlyMobile()) {
          <div class="top-pagination">
            <div class="d-flex">
              @if (_editableGridData.itemsCount || _editableGridData.noCount) {
                <dhs-pagination
                  [gridConfig]="_editableGridData" [itemsCount]="_editableGridData.itemsCount"
                  [limit]="_editableGridData.page_size" [startPage]="_editableGridData.page_no+1"
                  (pageChange)="onPageChanged($event)" (onLimitChanges)="onLimit($event.target.value)" class="d-flex"
                  (onConfigChanges)="pageConfigChange($event)">
                </dhs-pagination>
              }
            </div>
          </div>
        }
      </div>
      @if (utilService.isOnlyMobile()) {
        <div class="_mobile-pagination-container">
          <div [hidden]="!_editableGridData.itemsCount>0" class="">
            @if (_editableGridData.itemsCount || _editableGridData.noCount) {
              <dhs-pagination id="grid-mobile-pagination"
                [gridConfig]="_editableGridData"
                [itemsCount]="_editableGridData.itemsCount" [limit]="_editableGridData.page_size"
                [startPage]="_editableGridData.page_no+1" (pageChange)="onPageChanged($event)"
                (onLimitChanges)="onLimit($event.target.value)" (onConfigChanges)="pageConfigChange($event)">
              </dhs-pagination>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
@if (_editableGridData.filter_block!=undefined && _editableGridData.filter_block) {
  <div class="row filter-grid">
    <div class="col-12 pl-4 pr-4" [hidden]="!_editableGridData.filter">
      <div class="grid_filter">
        <div class="filter-body">
          <!-- <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span> -->
          <span class="close-filter-btn" (click)="displayFilter()">
            <i class="fa fa-times-circle" aria-hidden="true"></i></span>
            <div class="filter-form">
              <kx-filter (getData)="getDataFn($event)" [config]="searchConfig" [persistValue]="searchConfig"
                [fields]="_editableGridData.filter_block" (getFilter)="doSearch($event)" (resetFilter)=resetFilter($event)
                (resetQuickFilter)="resetQuickFilter()" #kxFilter>
              </kx-filter>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (_editableGridData.items!=undefined && _editableGridData.items.length!=undefined && _editableGridData.items.length>0) {
    <form [formGroup]="userForm">
      <div class="col-12 table-container pl-0 pr-0">
        <div id="data-grid" class="table-responsive tableFixHead">
          <table class="base-table table-actions bulk-result-entry-table" id="editable-grid">
            <thead>
              <tr>
                <th scope="col" class="editable-th-checkbox">
                  <label class="check-wrapper">
                    <input (change)="onAllChecked($event.target.checked)" tabindex="-1"
                      [checked]="_editableGridData.items.length === selectedItems.length && _editableGridData.items.length > 0"
                      type="checkbox" class="checkbox">
                    <span class="check-mark"></span>
                  </label>
                </th>
                @for (field of _editableGridData.fields; track field; let lst = $last) {
                  @if (field.controlType !='hidden' && !field.hidden) {
                    <th scope="col" [attr.data-name]="field.key">
                      @if (field.label !=false) {
                        <div class="th-editable-grid">
                          @if (field.sortable!=undefined && field.sortable) {
                            <span (click)="onSort(field)"
                              [ngClass]="{'fa-sort': !currentSort.get(field.key), 'fa-sort-desc': currentSort.get(field.key) === -1,'fa-sort-asc': currentSort.get(field.key) === 1}"
                              class="fa fa-sort kx-table-sort">&nbsp;&nbsp;
                            </span>
                          }
                          <ng-template #sortPopoverTemplate>
                            Remove Sorting
                          </ng-template>
                          @if (currentSort && (currentSort.get(field.key) === -1 || currentSort.get(field.key) === 1)) {
                            <span [popover]="sortPopoverTemplate" container="body" triggers="mouseenter:mouseleave"
                              placement="bottom" containerClass="info-popover"
                              class="fa fa-times-circle-o editable-remove-sorting" (click)="clearSort()">&nbsp;&nbsp;
                            </span>
                          }
                          <label [ngClass]="field.required?'required':''">{{ field.label | translate | async}}</label>
                          <!-- <span *ngIf="field.conversion" style="margin-top: -6px"> &nbsp;<i [ngClass]="field.conversion?'fa fa-info-circle':''"></i></span> -->
                        </div>
                        <!-- <sup *ngIf="field.required" class="req">*</sup> -->
                      }
                    </th>
                  }
                }
                <th>{{ 'field.label.action'| translate | async}}</th>
              </tr>
            </thead>
            @if (eg_grid_data != undefined && _editableGridData.items != undefined && eg_grid_data.length > 0) {
              <tbody>
                @for (group of getFormData.controls; track groupTrackById(i, group); let i = $index; let l = $last) {
                  <ng-container formArrayName="users"
                    >
                    <tr [formGroupName]="i">
                      <td class="form-group editable-th-checkbox" scope="row">
                        <label class="check-wrapper">
                          <input (change)="onItemChecked($event.target.checked, i)" [checked]="selectedIndices[i]"
                            type="checkbox" class="checkbox" tabindex="-1">
                          <span class="check-mark"></span>
                        </label>
                        @if (data['accessionIdentifierUncheck']!=undefined && data['accessionIdentifierUncheck']) {
                          <span class="clear-checkbox" (click)="uncheck(i,false)" data-toggle="tooltip" data-placement="top"
                            title="Deselect Accession No."><i class="fa fa-times" aria-hidden="true"></i></span>
                          }
                        </td>
                        @for (field of eg_grid_data[i]; track trackByValue(j, field); let j = $index) {
                          <td scope="row" class="form-group"
                            [ngClass]="field.controlType =='hidden' || field.hidden ?'d-none':''">
                            <div>
                              @switch (field.controlType) {
                                @case ('label') {
                                  <div>
                                    <!-- this  adds classes with no. spans   -->
                                    <!-- <ng-container *ngIf="field.class_conditions &&  !field.grid_color_text">
                                    <ng-container *ngFor="let class_ of commonService.getClass(this._editableGridData.items[i],field.class_conditions).split(' ')">
                                      <span [ngClass]="class_"> </span>
                                    </ng-container>
                                  </ng-container>
                                  <label *ngIf="field.type == undefined" [controlName]="field.name"></label> -->
                                  <!-- this span adds class for text color etc -->
                                  <!-- In ts -->
                                  <span id="label_{{i}}" class="_table-cell {{getConversionClass(field, i)}}"
                                    [attr.title]="getConversionTooltip(field, i)"
                                    [ngClass]="field.grid_color_text!=undefined && field.grid_color_text && field.class_conditions?(this._editableGridData.items[i] | getClass:field.class_conditions):''">
                                    @if (field.type === 'datetime') {
                                      <span>
                                        {{ field.value ? (field.value | dateTimeFormat) : ''}}
                                      </span>
                                    }
                                    @if (field.type === 'date') {
                                      <span>
                                        {{ field.value ? (field.value | dateFormat) : ''}}
                                      </span>
                                    }
                                    @if (field.type === 'time') {
                                      <span>
                                        {{ field.value ? (field.value | timeFormat) : ''}}
                                      </span>
                                    }
                                    @if (field.type?.toLowerCase() === 'string') {
                                      @if (getPopover(field, popoverTemplate, details) && hoveredPopoverCell === field.key + '_' + i) {
                                        <span [attr.id]="field.key + '_' + i"
                                          [popover]="getPopover(field, popoverTemplate, details)" placement="top"
                                          container="body" triggers="mouseenter:mouseleave" [outsideClick]="true"
                                          (mouseleave)="hoveredPopoverCell = null"
                                          (click)="isConversionAllowed(field, i) ? changeControls(field, i) : null">
                                          {{ field.value ? field.value : getDefaultValue(field, i) }}
                                        </span>
                                      } @else {
                                        <span [attr.id]="field.key + '_' + i"
                                          (mouseenter)="getPopover(field, popoverTemplate, details) ? hoveredPopoverCell = field.key + '_' + i : null"
                                          (click)="isConversionAllowed(field, i) ? changeControls(field, i) : null">
                                          {{ field.value ? field.value : getDefaultValue(field, i) }}
                                        </span>
                                      }
                                    }
                                    <ng-template #popoverTemplate>  {{ field.value }} </ng-template>
                                    @if (field.type === 'composite') {
                                      <span>
                                        {{ field.value ? (field.value) : ''}}
                                      </span>
                                    }
                                    @if (field.type === 'boolean' || field.type === 'Boolean') {
                                      <span>
                                        {{ field.value ? (field.value) : ''}}
                                      </span>
                                    }
                                    <!-- In ts -->
                                  </span>
                                </div>
                              }
                              @case ('checkbox') {
                                <div>
                                  <!-- <input type="checkbox" class="form-control" (change)="provisionalCheck($event, i)" [attr.disabled]="true" formControlName="isProvisional" /> -->
                                  <div class="checkbox-container provisional">
                                    <label class="check-wrapper">
                                      <input type="checkbox" checked="checked" [attr.disabled]="true"
                                        formControlName="isProvisional">
                                      <span class="check-mark"></span>
                                    </label>
                                  </div>
                                </div>
                              }
                              @case ('textbox') {
                                <div>
                                  @if ((field.key != undefined && field.key == 'remarks')) {
                                    <input class="form-control kx-input-default"
                                      type="text"
                                      [attr.disabled]="true" placeholder="Go to three dots for value" formControlName="remarks" />
                                  }
                                  @if ((field.key != undefined && field.key == 'impression')) {
                                    <input class="form-control kx-input-default"
                                      type="text"
                                      [attr.disabled]="true" placeholder="Go to three dots for value"
                                      formControlName="impression" />
                                  }
                                  @if ((field.key != undefined && field.key == 'advice')) {
                                    <input class="form-control kx-input-default"
                                      type="text" [attr.disabled]="true"
                                      placeholder="Go to three dots for value" formControlName="advice" />
                                  }
                                  @if ((field.key != undefined && field.key != 'remarks' && field.key != 'impression' && field.key != 'advice')) {
                                    <div
                                      style="height:unset; display: flex; align-items: center;">
                                      @if (group.value.isFormulaDependent!=undefined && group.value.isFormulaDependent) {
                                        <span (click)="formulaCalculation(userForm,group)"
                                          >
                                          <img src="assets/images/icon-calculate.png"
                                            style="height: 24px; width: 24px; margin-right:20px;">
                                        </span>
                                      }
                                      @if (group.value.resultType == 'numeric') {
                                        <input #resultBoxes class="form-control kx-input-default" id="resultType_{{i}}" [ngClass]="_editableGridData.items[i]['abnormalValueInterpretation'] != undefined && _editableGridData.items[i]['abnormalValueInterpretation'] != ''?'border_red':''"
                                          style="min-width: 150px;"
                                          formControlName="value" type="text" (keypress)="isNumberKey($event,group.value)"
                                          (change)="markChecked($event,i, group)"
                                          [attr.disabled]="group.value.status == 'Final'?true:null"
                                          onkeydown="javascript: return event.keyCode == 69 ? false : true" />
                                      }
                                    </div>
                                  }
                                  @if ((field.key != undefined && field.key != 'remarks' && field.key != 'impression' && field.key != 'advice') &&group.value.resultType == 'singleline') {
                                    <input class="form-control kx-input-default"
                                      formControlName="value" [attr.disabled]="group.value.status == 'Final'?true:null"
                                      type="textbox" (change)="markChecked($event,i)" id="resultType_{{i}}" />
                                  }
                                  @if ((field.key != undefined && field.key != 'remarks' && field.key != 'impression' && field.key != 'advice') &&group.value.resultType == 'advancetext') {
                                    <input class="form-control kx-input-default"
                                      type="text" [attr.disabled]="true" placeholder="Go to three dots for value"
                                      id="resultType_{{i}}" />
                                  }
                                </div>
                              }
                              @case ('dropdown') {
                                <div>
                                  @if (field.conversion) {
                                    <!-- label converted to a control on click (field.conversion) -->
                                    <dhs-form-question [insideGrid]="'true'" [index]="i" [question]="field"
                                      [form]="group" (valueChanged)="markChecked($event, i)">
                                    </dhs-form-question>
                                  } @else {
                                    <select class="form-control" style="min-width: 150px;"
                                      (change)="changeDropdownValue($event.target.value, i); markChecked($event,i)"
                                      formControlName="value" [attr.disabled]="group.value.status == 'Final'?true:null"
                                      id="resultType_{{i}}">
                                      <option value="">Select</option>
                                      @for (option of group.value.resultTypeDropDownValues; track option) {
                                        <option [value]="option.id">
                                          {{option.text}}
                                        </option>
                                      }
                                    </select>
                                  }
                                </div>
                              }
                            }
                          </div>
                        </td>
                      }
                      <!-- Last Action | Capability Column -->
                      @if (_editableGridData.listBlocks.hasOwnProperty('actions') && _editableGridData.nestedFields.length>0) {
                        <td noWrap class="tdmiddle" class="fixed-column"
                          >
                          <div
                            [ngClass]="_editableGridData.listBlocks.actions[0].conditions.length>0 ? '_last_column_editable_grid':''">
                            @for (act of _editableGridData.listBlocks.actions[0].conditions; track act; let iconIndex = $index; let lj = $last) {
                              <ng-container>
                                @if (getValue(group,act,i) && act.delete) {
                                  <span tabindex="-1" class="ca-actions p-2"
                                    (click)="removeRow(i)" (keydown.enter)="removeRow(i)">
                                    <span class="fa fa-trash"></span>
                                  </span>
                                }
                                @if (getValue(group,act,i) && act.redirect && (act.permission_required == undefined || act.permission_required == false || rolePermissionService.checkAccessPermission(act.action_name, act.resource, act.application))) {
                                  <span tabindex="-1"
                                    class="ca-actions pl-1" (click)="iconRedirect(group,act)"
                                    (keydown.enter)="iconRedirect(group,act)">
                                    <img src="assets/images/icons/emr-bulk-dark.svg" style="width:26px;">
                                  </span>
                                }
                              </ng-container>
                              @if (_editableGridData!=undefined && _editableGridData.capability!=undefined && _editableGridData.capability.length!=undefined && _editableGridData.capability.length>0 && lj) {
                                <ng-template #capabilityPopoverTemplate>
                                  @for (action of _editableGridData.capability; track action) {
                                    @if (rolePermissionService.checkAccessPermission(action.action_name, action.resource, action.application)) {
                                      <button
                                        triggers="focus" class="p-dropdown-item" (click)="emitEllipseId(group,action)">
                                        <i class="fa"></i>{{action.label| translate | async}}
                                      </button>
                                    }
                                  }
                                </ng-template>
                                <div class="table-row-actions d-inline-flex justify-content-center" [popover]="capabilityPopoverTemplate"
                                  container="body" containerClass="tabelcontextualmenu" [outsideClick]="true"
                                  placement="left top">
                                  <i class="fa fa-ellipsis-v"></i>
                                </div>
                              }
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  </ng-container>
                }
              </tbody>
            }
          </table>
        </div>
      </div>
    </form>
  }
  <div>
    <!-- {{userForm.value | json}} -->
  </div>
}
@if ((selectedIndices !=undefined && selectedIndices.length!=undefined && selectedIndices.length<= 0) && (config.showHeader!=undefined?!config.showHeader:true)) {
  <div class="no-record-found"
    >
    <!-- <p>No Records Available</p> -->
    <div class="no-record-found-img-container">
      <!--<img src="assets/images/icon-nodata.svg" />-->
      <img src="assets/images/nodata-icon.svg" class="no-records-found" />
      @if ( config && config.not_found_text==undefined) {
        <div class="no-records-found-text">
          <span>{{'field.label.no_records_found' | translate | async}}</span>
        </div>
      }
      @if (config && config.not_found_text!=undefined) {
        <div class="no-records-found-text">
          <span>{{config.not_found_text | translate | async}}</span>
        </div>
      }
    </div>
  </div>
}
